import React, { useEffect, useRef } from "react";
import iconRightArrow from "../../../../assets/images/icon-right-arrow.png";
import addAttribut from "../../../../assets/images/plus.png";
import { Button, Col, Container, Row } from "react-bootstrap";
import AttributRows from "./AttributRowsList";
import { useDispatch, useSelector } from "react-redux";
import {
  addAttributRow,
  clearAttributRow,
} from "../../../../redux/actions/createGridAttribut";
import "./style.css";

const ListeAttributes = ({ ficheAttribute, showFicheAttribute, grid }) => {
  const dispatch = useDispatch();
  const { attributesRow } = useSelector((state) => state.createGridAttribut);
  const { attributesIndex } = useSelector((state) => state.createGridAttribut);

  const { attributsByPerimetre, attributsByPerimetreSelect } = useSelector(
    (state) => state.attribut
  );

  const refListeAttributes = useRef();

  useEffect(() => {
    if (!grid || grid.length == 0 || attributesRow?.length == 0) {
      dispatch(clearAttributRow());

      const dataAtt = {
        attributesIndex,
        attribut: null,
        attributId: null,
        values: [],
      };
      dispatch(addAttributRow(dataAtt));
    }
  }, []);

  const addValue = () => {
    const data = {
      attributesIndex,
      attribut: null,
      attributId: null,
      values: [],
    };
    dispatch(addAttributRow(data));
  };

  const handleSubmit = () => {
    showFicheAttribute();
  };
  const useOnClickOutside = (refListeAttributes, handler) => {
    useEffect(() => {
      const listener = (event) => {
        if (
          !refListeAttributes.current ||
          refListeAttributes.current.contains(event.target)
        ) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [refListeAttributes, handler]);
  };
  const clearAndBack = () => {
    if (!grid || grid.length == 0) {
      dispatch(clearAttributRow());
      showFicheAttribute();
    } else {
      showFicheAttribute();
    }
  };
  useOnClickOutside(refListeAttributes, () => {
    showFicheAttribute();
    clearAndBack();
  });

  return (
    <div>
      <Container>
        <Row ref={refListeAttributes}>
          <nav
            className={
              ficheAttribute
                ? "fiche-attribut-grille-nav active"
                : "fiche-user-nav"
            }
          >
            <div className="container-topbar-of-callibrage">
              <div
                className="container-icon-arraw-left"
                onClick={() => {
                  {
                    clearAndBack();
                  }
                }}
              >
                <img src={iconRightArrow} />
              </div>

              <span className="detail-Attribut-title"> Attributs </span>
            </div>

            <div
              className="fiche-attribut-sub-header"
              style={{ height: "auto", margin: 10 }}
            >
              <img
                alt="addAttributListe"
                src={addAttribut}
                style={{ cursor: "pointer", width: "30px" }}
                onClick={() => addValue()}
              />
            </div>
            <div className="scroll-block">
              {attributesRow?.map((item, k) => (
                <div className="liste" key={k}>
                  <AttributRows item={item} />
                </div>
              ))}
            </div>
            <Row className="block-btns">
              <Col xs={11} md={11} className="block-btns-col">
                <Button
                  variant="primary"
                  className="buttons"
                  style={{
                    backgroundColor: "white",
                    borderColor: "gray",
                    color: "gray",
                  }}
                  onClick={() => {
                    clearAndBack();
                  }}
                >
                  Annuler
                </Button>
                <Button
                  variant="primary"
                  className="buttons"
                  style={{
                    backgroundColor: "#5800e2",
                    marginLeft: "5px",
                  }}
                  onClick={handleSubmit}
                >
                  Enregistrer
                </Button>
              </Col>
            </Row>
          </nav>
        </Row>
        <Row className="background-fiche-attribut"></Row>
      </Container>
    </div>
  );
};

export default ListeAttributes;
